import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const Button = ({
  children, className, onClick, text, type,
}) => (
  // eslint-disable-next-line react/button-has-type
  <button
    type={type || 'button'}
    key={text}
    className={cn(className)}
    onClick={onClick}
  >
    {children}
  </button>
);

Button.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  onClick: PropTypes.func,
  text: PropTypes.string,
  type: PropTypes.string,
};

Button.defaultProps = {
  children: undefined,
  className: undefined,
  onClick: undefined,
  text: undefined,
  type: undefined,
};

export default (Button);
